module.exports = __webpack_public_path__ + "img/APP-ICON@2x.1ac5f366.png";